<div>
  <tabset #mediaTabs class="tab-icons d-block" type="pills">
    <tab *ngIf="!allService.isTouchDevice">
      <ng-template tabHeading>
        <i-feather tooltip="Эмодзи" placement="bottom" name="smile" class="icon-lg"></i-feather>
      </ng-template>
      <emoji-mart
        [isNative]="interfaceService.supportEmoji"
        [enableSearch]="false"
        [showSingleCategory]="true"
        [i18n]="i18n"
        emoji="point_up"
        set="facebook"
        title="Смайлы"
        (emojiSelect)="addEmoji($event)"
      ></emoji-mart>
    </tab>
    <tab *ngIf="true">
      <ng-template tabHeading>
        <i-feather tooltip="Стикеры" placement="bottom" name="sticker" class="icon-lg"></i-feather>
      </ng-template>
      <div class="p-5">
        <alert [type]="'danger'"> Функционал в разработке </alert>
      </div>
    </tab>
    <tab *ngIf="true">
      <ng-template tabHeading>
        <i-feather tooltip="GIF" placement="bottom" name="film" class="icon-lg"></i-feather>
      </ng-template>
      <div class="p-5">
        <alert [type]="'danger'"> Функционал в разработке </alert>
      </div>
    </tab>
  </tabset>
</div>
